<!-- desktop template -->
<div *appIsDesktop>
  <app-search-product></app-search-product>
  <div class="main-container">
    <div class="product-nav">
      <span id="productCatalogs">{{ appStrings.products_productCatalogs }}</span>
      <mat-divider></mat-divider>
    </div>
    <div id="catalogsContainer" class="catalogs-container">
      @for (catalog of catalogs; track catalog; let i = $index) {
        <div id="catalogContainer_{{i}}" class="catalog-item catalog-card"
          >
          <a id="catalogLink_{{i}}" [routerLink]="['/tools/categories', catalog.catalogCode]">
            <img id="catalogLogo_{{i}}" [src]="catalog.logo" alt="{{catalog.name}}_logo" class="catalog-logo">
            <span id="catalogName_{{i}}" class="product-name catalog-name">{{ catalog.name }}</span>
          </a>
        </div>
      }
    </div>
  </div>
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  <app-breadcrumbs></app-breadcrumbs>
  <app-search-product></app-search-product>
  <div class="title">
    <span>{{ appStrings.menu_Products }}</span>
  </div>
  <span class="catalog-title">{{ appStrings.products_catalogs }}</span>
  <div id="catalogsContainer" class="catalogs-wrapper">
    @for (catalog of catalogs; track catalog; let i = $index) {
      <div id="catalogContainer_{{i}}">
        <mat-card appearance="outlined">
          <mat-card-content>
            <a id="catalogLink_{{i}}" [routerLink]="['/tools/categories', catalog.catalogCode]">
              <img id="catalogLogo_{{i}}" [src]="catalog.logo" alt="{{catalog.name}}_logo" class="catalog-logo">
              <span id="catalogName_{{i}}" class="catalog-name">{{ catalog.name }}</span>
            </a>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
</div>
